import { render, staticRenderFns } from "./AtomLoadingError.vue?vue&type=template&id=9d59f9fc&scoped=true&"
import script from "./AtomLoadingError.vue?vue&type=script&lang=js&"
export * from "./AtomLoadingError.vue?vue&type=script&lang=js&"
import style0 from "./AtomLoadingError.vue?vue&type=style&index=0&id=9d59f9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d59f9fc",
  null
  
)

/* custom blocks */
import block0 from "@/lang/AtomLoadingError.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fcommon%2FAtomLoadingError.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports